module.exports = __webpack_public_path__ + "img/brand-protection.cdfef973.svg";